import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const NewNotAuthorizedTitle: FC<IOuter> = () => <FormattedMessage id="empty-state.not-authorized-title-new" />;
